"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2735],{

/***/ 41961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ AuthHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/shared/assets/images/pag-lee-logo.png
var pag_lee_logo = __webpack_require__(78982);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
;// CONCATENATED MODULE: ./src/shared/components/AuthHeader/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 280px;\n  max-height: 100px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  margin: 0 auto;\n\n  > img {\n    object-fit: contain;\n    object-position: center;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n\n  > h1 {\n    line-height: 36px;\n    font-size: 22px;\n    color: ",
        ";\n    font-weight: 600;\n    margin-bottom: ",
        ";\n  }\n\n  > p {\n    font-size: 16px;\n    font-weight: 400;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}

const LogoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5a7a0ced-0"
})(_templateObject());
const Container = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-5a7a0ced-1"
})(_templateObject1(), (param)=>{
    let { theme  } = param;
    return "calc(".concat(theme.spacing.lg, " + ").concat(theme.spacing.lg, ")");
}, (param)=>{
    let { theme  } = param;
    return theme.colors.onSurface;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.xxs;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.gray[300];
});

;// CONCATENATED MODULE: ./src/shared/components/AuthHeader/index.tsx




const AuthHeader = (param)=>{
    let { title , subtitle , customLogo  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: customLogo || pag_lee_logo/* default */.Z,
                    alt: "PagLee",
                    width: 200,
                    height: 60
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: subtitle
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 22025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ AuthLink; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
;// CONCATENATED MODULE: ./src/shared/components/AuthLink/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  color: ",
        ";\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n  width: 100%;\n\n  transition: opacity 0.3s ease-in;\n\n  > svg {\n    width: 13px;\n    height: 13px;\n    stroke-width: 3px;\n  }\n\n  > span {\n    font-size: 13px;\n    line-height: 13px;\n    font-weight: 600;\n  }\n\n  &:hover {\n    opacity: 0.65;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const Container = (0,styled_components_browser_esm/* default */.ZP)((link_default())).withConfig({
    componentId: "sc-ff9906-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.spacing.md;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.gray[600];
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.xs;
});

;// CONCATENATED MODULE: ./src/shared/components/AuthLink/index.tsx


const AuthLink = (param)=>{
    let { href , icon: Icon , title  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        href: href,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: title
            })
        ]
    });
};


/***/ }),

/***/ 67399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./src/shared/interfaces/IMarginProps.ts
var IMarginProps = __webpack_require__(74466);
;// CONCATENATED MODULE: ./src/shared/components/Button/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n\n  height: ",
        ";\n  border-radius: ",
        ";\n  background: ",
        ";\n  border: ",
        ";\n  color: ",
        ";\n  padding: ",
        ";\n\n  font-size: ",
        ";\n  letter-spacing: 0.5px;\n  font-weight: 600;\n  line-height: ",
        ";\n\n  transition: all 0.3s ease-in;\n\n  svg {\n    transition: color 0.3s ease-in;\n\n    stroke-width: 3px;\n    width: 12px;\n    height: 12px;\n    color: ",
        ";\n  }\n\n  &:hover:not(:disabled) {\n    filter: brightness(0.96);\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    border-color: ",
        ";\n    background-color: ",
        ";\n    color: ",
        ";\n\n    svg {\n      color: ",
        ";\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const getHeight = {
    lg: "48px",
    md: "42px",
    sm: "36px"
};
const Container = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-60ff0aae-0"
})(_templateObject(), (param)=>{
    let { theme , size  } = param;
    return size === "sm" ? theme.spacing.xs : theme.spacing.sm;
}, (param)=>{
    let { size  } = param;
    return getHeight[size];
}, (param)=>{
    let { theme  } = param;
    return theme.borderRadius.sm;
}, (param)=>{
    let { theme , backgroundColor  } = param;
    return theme.colors[backgroundColor];
}, (param)=>{
    let { theme , backgroundColor , borderColor  } = param;
    return "1px solid ".concat(theme.colors[borderColor || backgroundColor]);
}, (param)=>{
    let { theme , textColor  } = param;
    return theme.colors[textColor];
}, (param)=>{
    let { theme , size  } = param;
    return "0 ".concat(size === "sm" ? theme.spacing.sm : theme.spacing.md);
}, (param)=>{
    let { size  } = param;
    return size === "lg" ? "14px" : "12px";
}, (param)=>{
    let { size  } = param;
    return getHeight[size];
}, (param)=>{
    let { theme , textColor  } = param;
    return theme.colors[textColor];
}, (param)=>{
    let { theme  } = param;
    return theme.colors.disabledBackground;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.disabledBackground;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.onDisabledBackground;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.onDisabledBackground;
}, IMarginProps/* marginPropsStyles */.b);

// EXTERNAL MODULE: ./src/shared/components/Tooltip/index.tsx
var Tooltip = __webpack_require__(10554);
// EXTERNAL MODULE: ./src/shared/components/Loader/index.ts
var Loader = __webpack_require__(10183);
;// CONCATENATED MODULE: ./src/shared/components/Button/index.tsx




const Button = (param)=>{
    let { isLoading , disabled , children , backgroundColor ="primary" , textColor ="onPrimary" , size ="md" , borderColor , m , mt , mb , ml , mr , mv , mh , disabledHint , type ="button" , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
        label: disabled && disabledHint,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                ...props,
                disabled: isLoading || disabled,
                backgroundColor: backgroundColor,
                textColor: textColor,
                borderColor: borderColor,
                m: m,
                mt: mt,
                mb: mb,
                mr: mr,
                ml: ml,
                mv: mv,
                mh: mh,
                size: size,
                id: "button",
                type: type,
                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                    color: "onDisabledBackground"
                }) : children
            })
        })
    });
};


/***/ }),

/***/ 23058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ ControlledInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87536);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17668);




const BaseControlledInput = (param, ref)=>{
    let { control , name , error , onChange , disableHookFormOnChange , mask , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_3__/* .Controller */ .Qr, {
        name: name,
        control: control,
        render: (param)=>{
            let { field: { onChange: fieldOnChange , value  } , formState: { errors  }  } = param;
            var ref1;
            const handleChange = (event)=>{
                const newEvent = {
                    ...event
                };
                if (mask) {
                    newEvent.target.value = mask(newEvent.target.value);
                }
                onChange === null || onChange === void 0 ? void 0 : onChange(newEvent);
                if (!disableHookFormOnChange) fieldOnChange(newEvent);
            };
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .I, {
                ...props,
                name: name,
                ref: ref,
                value: props.value || value || "",
                error: (error === null || error === void 0 ? void 0 : error.message) || (errors === null || errors === void 0 ? void 0 : (ref1 = errors[name]) === null || ref1 === void 0 ? void 0 : ref1.message) || "",
                onChange: handleChange
            });
        }
    });
};
const ControlledInput = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(BaseControlledInput);


/***/ }),

/***/ 20840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ ErrorMessage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./src/shared/interfaces/IMarginProps.ts
var IMarginProps = __webpack_require__(74466);
;// CONCATENATED MODULE: ./src/shared/components/Form/ErrorMessage/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  display: inline-block;\n  width: 100%;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 600;\n\n  letter-spacing: 0.5px;\n\n  ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const Text = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-2f3bbe44-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.danger;
}, IMarginProps/* marginPropsStyles */.b);

// EXTERNAL MODULE: ./src/shared/components/Collapse/index.tsx
var Collapse = __webpack_require__(89903);
;// CONCATENATED MODULE: ./src/shared/components/Form/ErrorMessage/index.tsx



const ErrorMessage = (param)=>{
    let { children , id , m , mb , mh , ml , mr , mt , mv  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* Collapse */.U, {
        isOpen: !!children,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
            id: id,
            m: m,
            mb: mb,
            mt: mt,
            ml: ml,
            mr: mr,
            mv: mv,
            mh: mh,
            children: children
        })
    });
};


/***/ }),

/***/ 24293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* binding */ FormGroup; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
;// CONCATENATED MODULE: ./src/shared/components/Form/FormGroup/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: ",
        ";\n\n  > * {\n    min-width: ",
        ";\n    flex: 1;\n  }\n\n  & + & {\n    margin-top: ",
        ";\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-46aa46e1-0"
})(_templateObject(), (param)=>{
    let { theme , spacing  } = param;
    return theme.spacing[spacing];
}, (param)=>{
    let { minWidth  } = param;
    return minWidth;
}, (param)=>{
    let { theme , spacing  } = param;
    return theme.spacing[spacing];
});

;// CONCATENATED MODULE: ./src/shared/components/Form/FormGroup/index.tsx


const FormGroup = (param)=>{
    let { children , minWidth ="200px" , spacing ="md" , style  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        style: style,
        spacing: spacing,
        minWidth: minWidth,
        id: "form-group",
        children: children
    });
};


/***/ }),

/***/ 17668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ Input; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./src/shared/hooks/useCopyToClipboard.ts
var useCopyToClipboard = __webpack_require__(3055);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./src/shared/interfaces/IMarginProps.ts
var IMarginProps = __webpack_require__(74466);
;// CONCATENATED MODULE: ./src/shared/components/Form/Input/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border-color: ",
        " !important;\n\n      svg {\n        color: ",
        " !important;\n      }\n    "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n    "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n        padding-right: 0;\n      "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n        padding-left: 0;\n      "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n\n  height: ",
        ";\n  border-radius: ",
        ";\n  background: ",
        ";\n  border: ",
        ";\n\n  transition: all ease-in 0.2s;\n  overflow: hidden;\n\n  &:focus-within {\n    border-color: ",
        ";\n  }\n\n  ",
        "\n\n  ",
        "\n\n  > input {\n    background: none;\n    height: 100%;\n    flex: 1;\n    padding: ",
        ";\n    font-size: ",
        ";\n    line-height: ",
        ";\n    color: ",
        ";\n\n    ",
        "\n\n    ",
        "\n\n    &::placeholder {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  height: 100%;\n  width: ",
        ";\n\n  > svg {\n    width: 18px;\n    height: 18px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  height: 100%;\n  min-width: ",
        ";\n\n  > svg {\n    min-width: 18px;\n    min-height: 18px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  height: 100%;\n  padding: 0 12px;\n  border-right: ",
        ";\n  font-size: ",
        ";\n  font-weight: 600;\n  color: ",
        ";\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  height: 100%;\n  width: ",
        ";\n\n  > svg {\n    min-width: 18px;\n    min-height: 18px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n  font-weight: 400;\n\n  width: ",
        ";\n  height: 100%;\n\n  > svg {\n    min-width: 16px;\n    min-height: 16px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}


const Container = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-62943cab-0"
})(_templateObject(), IMarginProps/* marginPropsStyles */.b);
const getHeight = {
    lg: "48px",
    md: "42px",
    sm: "36px"
};
const InputWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-62943cab-1"
})(_templateObject5(), (param)=>{
    let { size  } = param;
    return getHeight[size];
}, (param)=>{
    let { theme  } = param;
    return theme.borderRadius.sm;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.surface;
}, (param)=>{
    let { theme  } = param;
    return "1px solid ".concat(theme.colors.gray[100]);
}, (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, (param)=>{
    let { theme , hasError  } = param;
    return hasError && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), theme.colors.danger, theme.colors.danger);
}, (param)=>{
    let { isDisabled , theme  } = param;
    return isDisabled && (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), theme.colors.gray[50]);
}, (param)=>{
    let { theme , size  } = param;
    return "0 ".concat(size === "lg" ? theme.spacing.sm : "12px");
}, (param)=>{
    let { size  } = param;
    return size === "sm" ? "12px" : "14px";
}, (param)=>{
    let { size  } = param;
    return getHeight[size];
}, (param)=>{
    let { theme  } = param;
    return theme.colors.onSurface;
}, (param)=>{
    let { isTypePassword  } = param;
    return isTypePassword && (0,styled_components_browser_esm/* css */.iv)(_templateObject3());
}, (param)=>{
    let { hasIcon  } = param;
    return hasIcon && (0,styled_components_browser_esm/* css */.iv)(_templateObject4());
}, (param)=>{
    let { theme  } = param;
    return theme.colors.gray[200];
});
const IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-62943cab-2"
})(_templateObject6(), (param)=>{
    let { inputSize  } = param;
    return getHeight[inputSize];
}, (param)=>{
    let { theme  } = param;
    return theme.colors.onSurface;
});
const EndContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-62943cab-3"
})(_templateObject7(), (param)=>{
    let { inputSize  } = param;
    return getHeight[inputSize];
}, (param)=>{
    let { theme  } = param;
    return theme.colors.onSurface;
});
const StartContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-62943cab-4"
})(_templateObject8(), (param)=>{
    let { theme  } = param;
    return "1px solid ".concat(theme.colors.gray[100]);
}, (param)=>{
    let { inputSize  } = param;
    return inputSize === "sm" ? "12px" : "14px";
}, (param)=>{
    let { theme  } = param;
    return theme.colors.onSurface;
});
const PasswordButton = styled_components_browser_esm/* default.button.attrs */.ZP.button.attrs({
    type: "button"
}).withConfig({
    componentId: "sc-62943cab-5"
})(_templateObject9(), (param)=>{
    let { inputSize  } = param;
    return getHeight[inputSize];
}, (param)=>{
    let { theme  } = param;
    return theme.colors.onSurface;
});
const CopyButton = styled_components_browser_esm/* default.button.attrs */.ZP.button.attrs({
    type: "button"
}).withConfig({
    componentId: "sc-62943cab-6"
})(_templateObject10(), (param)=>{
    let { theme  } = param;
    return theme.spacing.xs;
}, (param)=>{
    let { inputSize  } = param;
    return getHeight[inputSize];
}, (param)=>{
    let { theme  } = param;
    return theme.colors.onSurface;
});

// EXTERNAL MODULE: ./src/shared/components/Form/Label/index.tsx + 1 modules
var Label = __webpack_require__(26314);
// EXTERNAL MODULE: ./src/shared/components/Form/ErrorMessage/index.tsx + 1 modules
var ErrorMessage = __webpack_require__(20840);
// EXTERNAL MODULE: ./src/shared/components/Tooltip/index.tsx
var Tooltip = __webpack_require__(10554);
;// CONCATENATED MODULE: ./src/shared/components/Form/Input/index.tsx








const BaseInput = (param, ref)=>{
    let { label , icon: Icon , startContent , endContent , type , error , m , ml , mr , mt , mh , mb , mv , size ="md" , containerStyle ={} , id: propsId , disabled , enableCopyButton =false , disabledHint , ...props } = param;
    const id = (0,react.useId)();
    const errorId = "".concat(propsId || id, "-error");
    const { copy  } = (0,useCopyToClipboard/* useCopyToClipboard */.m)();
    const [isPasswordVisible, setIsPasswordVisible] = (0,react.useState)(false);
    const toggleIsPasswordVisible = ()=>{
        setIsPasswordVisible((prevState)=>!prevState);
    };
    const handleCopyValue = ()=>{
        const successMessage = "Boa, ".concat(label || "valor", " copiado com sucesso!");
        const errorMessage = "Ops, n\xe3o foi poss\xedvel copiar o ".concat(label || "valor", "!");
        copy(String(props.value), {
            errorMessage,
            successMessage
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        m: m,
        mv: mv,
        mh: mh,
        mt: mt,
        mb: mb,
        ml: ml,
        mr: mr,
        htmlFor: propsId || id,
        children: [
            !!label && /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* Label */._, {
                mb: "xxs",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                label: disabledHint,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputWrapper, {
                    hasIcon: !!Icon,
                    isTypePassword: type === "password",
                    hasError: !!error,
                    size: size,
                    style: containerStyle,
                    isDisabled: disabled,
                    children: [
                        !!Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                            inputSize: size,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {})
                        }),
                        !!startContent && /*#__PURE__*/ (0,jsx_runtime.jsx)(StartContentWrapper, {
                            inputSize: size,
                            children: startContent
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: type === "password" ? isPasswordVisible ? "text" : "password" : type,
                            ...!!error && {
                                "aria-invalid": true,
                                "aria-describedby": errorId
                            },
                            ...props,
                            disabled: disabled,
                            id: propsId || id,
                            ref: ref
                        }),
                        enableCopyButton && !!props.value && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            label: label ? "Copiar ".concat(label) : "Copiar",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyButton, {
                                type: "button",
                                onClick: handleCopyValue,
                                inputSize: size,
                                ...(!!endContent || type === "password") && {
                                    style: {
                                        width: 20,
                                        marginLeft: 12
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiClipboard */.j4u, {})
                            })
                        }),
                        endContent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EndContentWrapper, {
                            inputSize: size,
                            children: endContent
                        }) : type === "password" && (enableCopyButton ? !!props.value : true) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            label: isPasswordVisible ? "Esconder ".concat(label || "senha") : "Mostrar ".concat(label || "senha"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PasswordButton, {
                                type: "button",
                                onClick: toggleIsPasswordVisible,
                                inputSize: size,
                                children: isPasswordVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiEyeOff */.rzC, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiEye */.rDJ, {})
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage/* ErrorMessage */.B, {
                id: errorId,
                mt: "xxs",
                children: error
            })
        ]
    });
};
const Input = /*#__PURE__*/ (0,react.forwardRef)(BaseInput);


/***/ }),

/***/ 26314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ Label; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./src/shared/interfaces/IMarginProps.ts
var IMarginProps = __webpack_require__(74466);
;// CONCATENATED MODULE: ./src/shared/components/Form/Label/styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: ",
        ";\n  font-size: 12px;\n  width: 100%;\n  text-align: left;\n  width: max-content;\n\n  letter-spacing: 0.5px;\n\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}


const Container = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-81f8e4ed-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.gray[600];
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.xxs;
}, IMarginProps/* marginPropsStyles */.b);
const HintWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-81f8e4ed-1"
})(_templateObject1());

// EXTERNAL MODULE: ./src/shared/components/Tooltip/index.tsx
var Tooltip = __webpack_require__(10554);
;// CONCATENATED MODULE: ./src/shared/components/Form/Label/index.tsx




const Label = (param)=>{
    let { children , hint , m , mb , mh , ml , mr , mt , mv , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        m: m,
        mb: mb,
        mh: mh,
        ml: ml,
        mr: mr,
        mt: mt,
        mv: mv,
        ...props,
        children: [
            children,
            !!hint && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                label: hint,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HintWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiInfo */.H33, {})
                })
            })
        ]
    });
};


/***/ }),

/***/ 10183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(186);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  from { transform: rotate(0deg) }\n  to { transform: rotate(360deg) }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n\n  min-width: ",
        "px;\n  max-width: ",
        "px;\n  min-height: ",
        "px;\n  max-height: ",
        "px;\n  border: ",
        ";\n  border-top-color: transparent;\n  border-radius: 50%;\n\n  animation: ",
        " 0.6s linear infinite;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}

const spinAnimation = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)(_templateObject());
const Loader = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-725a5f5d-0"
})(_templateObject1(), (param)=>{
    let { size  } = param;
    return typeof size !== "undefined" ? size : 16;
}, (param)=>{
    let { size  } = param;
    return typeof size !== "undefined" ? size : 16;
}, (param)=>{
    let { size  } = param;
    return typeof size !== "undefined" ? size : 16;
}, (param)=>{
    let { size  } = param;
    return typeof size !== "undefined" ? size : 16;
}, (param)=>{
    let { theme , color ="onPrimary"  } = param;
    return "1.5px solid ".concat(theme.colors[color]);
}, spinAnimation);


/***/ }),

/***/ 3055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ useCopyToClipboard; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useToast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64390);


function useCopyToClipboard() {
    const toast = (0,_useToast__WEBPACK_IMPORTED_MODULE_1__/* .useToast */ .p)();
    const [copiedText, setCopiedText] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    const isSupported = typeof navigator !== "undefined" && !!(navigator === null || navigator === void 0 ? void 0 : navigator.clipboard);
    const copy = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async function(text) {
        let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (!isSupported) return false;
        try {
            await navigator.clipboard.writeText(text);
            setCopiedText(text);
            if (options.successMessage) {
                toast.show({
                    title: options.successMessage,
                    variant: "success"
                });
            }
            return true;
        } catch (error) {
            if (options.errorMessage) {
                toast.show({
                    title: options.errorMessage,
                    variant: "error"
                });
            }
            setCopiedText(null);
            return false;
        }
    }, [
        toast,
        isSupported
    ]);
    return {
        copiedText,
        copy,
        isSupported
    };
}


/***/ }),

/***/ 47533:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ o; }
});

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
;// CONCATENATED MODULE: ./node_modules/@hookform/resolvers/dist/resolvers.mjs
var e=function(i,e,t){if(i&&"reportValidity"in i){var f=(0,index_esm/* get */.U2)(t,e);i.setCustomValidity(f&&f.message||""),i.reportValidity()}},resolvers_t=function(r,i){var t=function(t){var f=i.fields[t];f&&f.ref&&"reportValidity"in f.ref?e(f.ref,t,r):f.refs&&f.refs.forEach(function(i){return e(i,t,r)})};for(var f in i.fields)t(f)},f=function(e,f){f.shouldUseNativeValidation&&resolvers_t(e,f);var o={};for(var a in e){var n=(0,index_esm/* get */.U2)(f.fields,a);(0,index_esm/* set */.t8)(o,a,Object.assign(e[a],{ref:n&&n.ref}))}return o};
//# sourceMappingURL=resolvers.module.js.map

;// CONCATENATED MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs
var o=function(o,n,a){return void 0===n&&(n={}),void 0===a&&(a={}),function(s,i,c){try{return Promise.resolve(function(t,r){try{var u=(n.context&&"development"==="production"&&0,Promise.resolve(o["sync"===a.mode?"validateSync":"validate"](s,Object.assign({abortEarly:!1},n,{context:i}))).then(function(t){return c.shouldUseNativeValidation&&resolvers_t({},c),{values:a.rawValues?s:t,errors:{}}}))}catch(e){return r(e)}return u&&u.then?u.then(void 0,r):u}(0,function(e){if(!e.inner)throw e;return{values:{},errors:f((o=e,n=!c.shouldUseNativeValidation&&"all"===c.criteriaMode,(o.inner||[]).reduce(function(e,t){if(e[t.path]||(e[t.path]={message:t.message,type:t.type}),n){var o=e[t.path].types,a=o&&o[t.type];e[t.path]=(0,index_esm/* appendErrors */.KN)(t.path,n,e,t.type,a?[].concat(a,t.message):t.message)}return e},{})),c)};var o,n}))}catch(e){return Promise.reject(e)}}};
//# sourceMappingURL=yup.module.js.map


/***/ })

}]);